/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Category } from './Category';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
    CategoryToJSONTyped,
} from './Category';

/**
 * 
 * @export
 * @interface SubCategory
 */
export interface SubCategory {
    /**
     * 
     * @type {number}
     * @memberof SubCategory
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SubCategory
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof SubCategory
     */
    categoryId?: number;
    /**
     * 
     * @type {Category}
     * @memberof SubCategory
     */
    Category?: Category;
}

/**
 * Check if a given object implements the SubCategory interface.
 */
export function instanceOfSubCategory(value: object): value is SubCategory {
    return true;
}

export function SubCategoryFromJSON(json: any): SubCategory {
    return SubCategoryFromJSONTyped(json, false);
}

export function SubCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'Category': json['Category'] == null ? undefined : CategoryFromJSON(json['Category']),
    };
}

  export function SubCategoryToJSON(json: any): SubCategory {
      return SubCategoryToJSONTyped(json, false);
  }

  export function SubCategoryToJSONTyped(value?: SubCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'categoryId': value['categoryId'],
        'Category': CategoryToJSON(value['Category']),
    };
}

